import i18n from "@/i18n";
import { DefaultValidationCheckResult, ValidationCheckResultRest } from "@/types/generated/UsedGeneratedTypes";

type ParamsType = Record<string, any>;

const ERRORS: Record<string, (params: ParamsType) => string> = {
  // erreur yaml
  badBooleanRequiredSections: params =>
    i18n.global.t("errors-yaml.badBooleanRequiredSections.message", params),
  invalidIdentificateurs: params =>
    i18n.global.t("errors-yaml.badBooleanRequiredSections.message", params),
  badConstantImportHeaderRowNumber: params =>
    i18n.global.t("errors-yaml.badConstantImportHeaderRowNumber.message", params),
  badDomainTagPattern: params => i18n.global.t("errors-yaml.badDomainTagPattern.message", params),
  badEnumSectionType: params => i18n.global.t("errors-yaml.badEnumSectionType.message", params),
  badFloatRequiredSections: params =>
    i18n.global.t("errors-yaml.badFloatRequiredSections.message", params),
  badIntegerRequiredSections: params =>
    i18n.global.t("errors-yaml.badIntegerRequiredSections.message", params),
  badLocaleLabels: params => i18n.global.t("errors-yaml.badLocaleLabels.message", params),
  badLocaleSectionType: params =>
    i18n.global.t("errors-yaml.badLocaleSectionType.message", params),
  badTagsPatterns: params => i18n.global.t("errors-yaml.badTagsPatterns.message", params),
  badVersionPattern: params => i18n.global.t("errors-yaml.badVersionPattern.message", params),
  illegalDomainTagPattern: params =>
    i18n.global.t("errors-yaml.illegalDomainTagPattern.message", params),
  invalidComponentReferenceForAuthorizationScopeAuthorization: params =>
    i18n.global.t(
      "errors-yaml.invalidComponentReferenceForAuthorizationScopeAuthorization.message",
      params,
    ),
  invalidMinMaxForCheckerDate: params =>
    i18n.global.t("errors-yaml.invalidMinMaxForCheckerDate.message", params),
  invalidNaturalKey: params => i18n.global.t("errors-yaml.invalidNaturalKey.message", params),
  invalidPatternForCheckerDate: params =>
    i18n.global.t("errors-yaml.invalidPatternForCheckerDate.message", params),
  missingAnyMandatoriesSections: params =>
    i18n.global.t("errors-yaml.missingAnyMandatoriesSections.message", params),
  missingCheckerName: params => i18n.global.t("errors-yaml.missingCheckerName.message", params),
  missingColumnNameValidation: params =>
    i18n.global.t("errors-yaml.missingColumnNameValidation.message", params),
  missingComponentForComponentName: params =>
    i18n.global.t("errors-yaml.missingComponentForComponentName.message", params),
  missingConstantImportHeaderColumnOrRowNumber: params =>
    i18n.global.t("errors-yaml.missingConstantImportHeaderColumnOrRowNumber.message", params),
  missingConstantImportHeaderRowNumber: params =>
    i18n.global.t("errors-yaml.missingConstantImportHeaderRowNumber.message", params),
  missingMandatoriesSections: params =>
    i18n.global.t("errors-yaml.missingMandatoriesSections.message", params),
  missingNameApplication: params =>
    i18n.global.t("errors-yaml.missingNameApplication.message", params),
  missingPatternForCheckerDate: params =>
    i18n.global.t("errors-yaml.missingPatternForCheckerDate.message", params),
  missingReferenceAndComponentName: params =>
    i18n.global.t("errors-yaml.missingReferenceAndComponentName.message", params),
  missingReferenceName: params =>
    i18n.global.t("errors-yaml.missingReferenceName.message", params),
  missingRequiredEnumValue: params =>
    i18n.global.t("errors-yaml.missingRequiredEnumValue.message", params),
  missingRequiredValue: params =>
    i18n.global.t("errors-yaml.missingRequiredValue.message", params),
  missingVersionApplication: params =>
    i18n.global.t("errors-yaml.missingVersionApplication.message", params),
  negativeConstantImportHeaderRowNumber: params =>
    i18n.global.t("errors-yaml.negativeConstantImportHeaderRowNumber.message", params),
  negativeConstantImportHeaderColumnNumber: params =>
    i18n.global.t("errors-yaml.negativeConstantImportHeaderColumnNumber.message", params),
  notExpectedDomainTags: params =>
    i18n.global.t("errors-yaml.notExpectedDomainTags.message", params),
  undefinedComponentForAuthorizationScopeAuthorization: params =>
    i18n.global.t(
      "errors-yaml.undefinedComponentForAuthorizationScopeAuthorization.message",
      params,
    ),
  unexpectedSubmission: params =>
    i18n.global.t("errors-yaml.unexpectedSubmission.message", params),
  unexpectedSections: params => i18n.global.t("errors-yaml.unexpectedSections.message", params),
  unknownComponentForComponentName: params =>
    i18n.global.t("errors-yaml.unknownComponentForComponentName.message", params),
  unknownCheckerName: params => i18n.global.t("errors-yaml.unknownCheckerName.message", params),
  unknownNameAuthorizationScope: params =>
    i18n.global.t("errors-yaml.unknownNameAuthorizationScope.message", params),
  unknownReferenceName: params =>
    i18n.global.t("errors-yaml.unknownReferenceName.message", params),
  unknownReferenceColumnToLookForHeader: params =>
    i18n.global.t("errors-yaml.unknownReferenceColumnToLookForHeader.message", params),
  unknownStrategySubmission: params =>
    i18n.global.t("errors-yaml.unknownStrategySubmission.message", params),
  unsuportedI18nKeyLanguage: params =>
    i18n.global.t("errors-yaml.unsuportedI18nKeyLanguage.message", params),
  unsupportedNameApplication: params =>
    i18n.global.t("errors-yaml.unsupportedNameApplication.message", params),
  unsupportedOpenadomVersion: params =>
    i18n.global.t("errors-yaml.unsupportedOpenadomVersion.message", params),
  unsupportedVersionApplication: params =>
    i18n.global.t("errors-yaml.unsupportedVersionApplication.message", params),
  duplicatedComponentName: params =>
    i18n.global.t("errors-yaml.duplicatedComponentName.message", params),
  duplicatedComponentHeader: params =>
    i18n.global.t("errors-yaml.duplicatedComponentHeader.message", params),
  duplicatedComponentHeaderInPatternComponent: params =>
    i18n.global.t("errors-yaml.duplicatedComponentHeaderInPatternComponent.message", params),
  invalidConfigurationFile: params =>
    i18n.global.t("errors-yaml.invalidConfigurationFile.message", params),
  badGroovyExpression: params => i18n.global.t("errors-yaml.badGroovyExpression.message", params),
  unknownNameReferenceScope: params =>
    i18n.global.t("errors-yaml.unknownNameReferenceScope.message", params),
  invalidDurationCheckerDate: params =>
    i18n.global.t("errors-yaml.invalidDurationCheckerDate.message", params),
  missingComponentForDisplayPattern: params =>
    i18n.global.t("errors-yaml.missingComponentForDisplayPattern.message", params),
  manyComponentInNaturalKey: params =>
    i18n.global.t("errors-yaml.manyComponentInNaturalKey.message", params),
  duplicateKey: params =>
    i18n.global.t("errors-yaml.duplicateKey.message", params),
  invalidComponentReferenceForSubmissionScopeReference: params =>
    i18n.global.t("errors-yaml.invalidComponentReferenceForSubmissionScopeReference.message", params),

  // erreur csv
  badAuthorizationScopeForRepository: params =>
    i18n.global.t("errors-csv.badAuthorizationScopeForRepository.message", params),
  badMaxIntervalFloatWithComponent: params =>
    i18n.global.t("errors-csv.badMaxIntervalFloatWithComponent.message", params),
  badMinIntervalFloatWithComponent: params =>
    i18n.global.t("errors-csv.badMinIntervalFloatWithComponent.message", params),
  BAD_VALUE_FOR_EXPRESSION: params =>
    i18n.global.t("errors-csv.badValueForExpression.message", params),
  badValueForExpression: params =>
    i18n.global.t("errors-csv.badValueForExpression.message", params),
  duplicatedHeaders: params =>
    i18n.global.t("errors-csv.duplicatedHeaders.message", params),
  duplicatedLineInDatatype: params =>
    i18n.global.t("errors-csv.duplicatedLineInDatatype.message", params),
  duplicatedLineInReference: params =>
    i18n.global.t("errors-csv.duplicatedLineInReference.message", params),
  emptyFile: params => i18n.global.t("errors-csv.emptyFile.message", params),
  emptyHeader: params => i18n.global.t("errors-csv.emptyHeader.message", params),
  headerColumnPatternNotMatching: params =>
    i18n.global.t("errors-csv.headerColumnPatternNotMatching.message", params),
  invalidHeaders: params => i18n.global.t("errors-csv.invalidHeaders.message", params),
  invalidReferenceWithComponent: params =>
    i18n.global.t("errors-csv.invalidReferenceWithComponent.message", params),
  missingMandatoryColumns: params =>
    i18n.global.t("errors-csv.missingMandatoryColumns.message", params),
  timeRangeOutOfInterval: params =>
    i18n.global.t("errors-csv.timeRangeOutOfInterval.message", params),
  unexpectedHeaderColumn: params =>
    i18n.global.t("errors-csv.unexpectedHeaderColumn.message", params),
  unexpectedHeaderColumnsInList: params =>
    i18n.global.t("errors-csv.unexpectedHeaderColumnsInList.message", params),
  unexpectedTokenCount: params =>
    i18n.global.t("errors-csv.unexpectedTokenCount.message", params),
  invalidFloatWithComponent: params =>
    i18n.global.t("errors-csv.invalidFloatWithComponent.message", params),
  invalidIntegerWithComponent: params =>
    i18n.global.t("errors-csv.invalidIntegerWithComponent.message", params),
  invalidDateWithComponent: params =>
    i18n.global.t("errors-csv.invalidDateWithComponent.message", params),
  requiredValueWithComponent: params =>
    i18n.global.t("errors-csv.requiredValueWithComponent.message", params),
  missingParentLineInRecursiveReference: params =>
    i18n.global.t("errors-csv.missingParentLineInRecursiveReference.message", params),

  // erreur csv componentFilter
  componentFilter: params =>
    i18n.global.t("errors-csv.componentFilter.componentFilter.message", params),
  missingTypeForIntervalValue: params =>
    i18n.global.t("errors-csv.componentFilter.missingTypeForIntervalValue.message", params),
  missingFormatForIntervalValue: params =>
    i18n.global.t("errors-csv.componentFilter.missingFormatForIntervalValue.message", params),
  missingFormatForFilter: params =>
    i18n.global.t("errors-csv.componentFilter.missingFormatForFilter.message", params),
  missingFilter: params =>
    i18n.global.t("errors-csv.componentFilter.missingFilter.message", params),
  missingIdForUUID: params =>
    i18n.global.t("errors-csv.componentFilter.missingIdForUUID.message", params),
  missingComponentKeyForSearch: params =>
    i18n.global.t("errors-csv.componentFilter.missingComponentKeyForSearch.message", params),
  missingComponentKeyComponent: params =>
    i18n.global.t("errors-csv.componentFilter.missingComponentKeyComponent.message", params),
  missingrecursiveParentReferenceWithComponent: params =>
    i18n.global.t("errors-csv.componentFilter.missingrecursiveParentReferenceWithComponent.message", params),
  badFormatForStartDate: params =>
    i18n.global.t("errors-csv.componentFilter.badFormatForStartDate.message", params),
  badFormatForEndDate: params =>
    i18n.global.t("errors-csv.componentFilter.badFormatForEndDate.message", params),
  badrangeForDates: params =>
    i18n.global.t("errors-csv.componentFilter.badrangeForDates.message", params),
  badFormatForStartTime: params =>
    i18n.global.t("errors-csv.componentFilter.badFormatForStartTime.message", params),
  badFormatForEndTime: params =>
    i18n.global.t("errors-csv.componentFilter.badFormatForEndTime.message", params),
  badrangeForTimes: params =>
    i18n.global.t("errors-csv.componentFilter.badrangeForTimes.message", params),
  badFormatForStartDateTime: params =>
    i18n.global.t("errors-csv.componentFilter.badFormatForStartDateTime.message", params),
  badFormatForEndDateTime: params =>
    i18n.global.t("errors-csv.componentFilter.badFormatForEndDateTime.message", params),
  badrangeForDateTimes: params =>
    i18n.global.t("errors-csv.componentFilter.badrangeForDateTimes.message", params),
  badFormatForStartNumeric: params =>
    i18n.global.t("errors-csv.componentFilter.badFormatForStartNumeric.message", params),
  badFormatForEndNumeric: params =>
    i18n.global.t("errors-csv.componentFilter.badFormatForEndNumeric.message", params),
  badrangeForNumerics: params =>
    i18n.global.t("errors-csv.componentFilter.badrangeForNumerics.message", params),
  missingFilterOrInterval: params =>
    i18n.global.t("errors-csv.componentFilter.missingFilterOrInterval.message", params),
  missingComponentForDatatype: params =>
    i18n.global.t("errors-csv.componentFilter.missingComponentForDatatype.message", params),
  missingFormatForFilterDate: params =>
    i18n.global.t("errors-csv.componentFilter.missingFormatForFilterDate.message", params),
  badFormatForFilterDate: params =>
    i18n.global.t("errors-csv.componentFilter.badFormatForFilterDate.message", params),
  notIntervalValueTypeForcomponent: params =>
    i18n.global.t("errors-csv.componentFilter.notIntervalValueTypeForcomponent.message", params),
  badPatternForDate: params =>
    i18n.global.t("errors-csv.componentFilter.badPatternForDate.message", params),

  // erreur login
  EXPIRED_VALIDATION_KEY: params =>
    i18n.global.t("exceptionMessage.EXPIRED_VALIDATION_KEY", params),
  INACTIVE_ACCOUNT: params => i18n.global.t("exceptionMessage.INACTIVE_ACCOUNT", params),
  PENDING_ACCOUNT: params => i18n.global.t("exceptionMessage.PENDING_ACCOUNT", params),
  CLOSED_ACCOUNT: params => i18n.global.t("exceptionMessage.CLOSED_ACCOUNT", params),
  BAD_LOGIN_PASSWORD: params => i18n.global.t("exceptionMessage.BAD_LOGIN_PASSWORD", params),
  BAD_VALIDATION_KEY: params => i18n.global.t("exceptionMessage.BAD_VALIDATION_KEY", params),
  BAD_LOGIN_OR_EMAIL_PASSWORD: params =>
    i18n.global.t("exceptionMessage.BAD_LOGIN_OR_EMAIL_PASSWORD", params),
  BAD_PASSWORDS: params => i18n.global.t("exceptionMessage.BAD_PASSWORDS", params),
  patternNotMatchedWithComponent: params =>
    i18n.global.t("exceptionMessage.patternNotMatchedWithComponent", params),
};

export class ErrorsService {
  static INSTANCE: ErrorsService = new ErrorsService();

  getErrorsMessages(errors: string | DefaultValidationCheckResult[], params?: any | null, type?: string): string | string[] {
    if (typeof errors === "string") {
      switch (type) {
        case "errors-yaml.":
          return i18n.global.t(type + errors + ".message", this.transformeArrayParams(params));
        case "errors-csv.":
          return i18n.global.t(type + errors, this.transformeArrayParams(params));
        default:
          return i18n.global.t("errors." + errors, this.transformeArrayParams(params));
      }
    }
    else {
      return errors.map((error) => {
        const func = ERRORS[error.message];
        if (!func) {
          // throw new Error("Il manque la chaine de traduction pour l'erreur : " + error.message);
          return i18n.global.t("errors.exception");
        }
        return func(error.messageParams);
      });
    }
  }

  getErrorsLoginMessages(errors: string, params: any): string | undefined {
    return i18n.global.t("exceptionMessage." + errors, this.transformeArrayParams(params));
  }

  transformeArrayParams(params: any): any {
    if (!params || params.toString() !== "[object Object]") {
      return params;
    }

    return Object.fromEntries(
      Object.entries(params).map(([key, value]) => {
        if (Array.isArray(value)) {
          return [
            key,
            value.map(s =>
              typeof s === "string" ? `<span class="messageElement">${s}</span>` : s,
            ),
          ];
        }
        return [key, value];
      }),
    );
  }

  getCsvErrorsMessages(csvErrors: ValidationCheckResultRest[], componentDescriptions?: any): string[] {
    return csvErrors.map((csvError) => {
      const func = ERRORS[csvError.message];

      if (csvError.params.component != null) {
        csvError.params.target = csvError.params.component;
        if (componentDescriptions && componentDescriptions[csvError.params.target]?.importHeader) {
          csvError.params.component = componentDescriptions[csvError.params.target].importHeader;
        }
        else if (componentDescriptions && componentDescriptions[csvError.params.target]?.componentKey) {
          csvError.params.component = componentDescriptions[csvError.params.target].componentKey;
        }
      }
      if (csvError.params.target != null) {
        if (csvError.params.target.column != null) {
          csvError.params.target = csvError.params.target.column;
        }
        if (csvError.params.target.id != null) {
          csvError.params.target = csvError.params.target.id;
        }
      }
      if (csvError.params?.expression?.expression != null) {
        csvError.params.target = csvError.params.expression.expression;
      }
      if (csvError.params.expectedValue != null || csvError.params.givenValue != null) {
        if (csvError.params.expectedValue.sql != null) {
          csvError.params.expectedValue = csvError.params.expectedValue.sql;
        }
        if (csvError.params.givenValue.sql != null) {
          csvError.params.givenValue = csvError.params.givenValue.sql;
        }
      }
      if (!func) {
        // throw new Error("Il manque la chaine de traduction pour l'erreur : " + csvError.validationCheckResult.message);
        return i18n.global.t("errors.exception") + csvError.message;
      }
      const params = {
        lineNumber: csvError.lineNumber,
        ...this.transformeArrayParams(csvError.params),
      };
      return func(params);
    });
  }

  getAllErrorMessagesI18n(): string {
    // i18n.changeLanguage(locale);

    const errorMessages: Record<string, { message: string; title: string }> = {};

    Object.keys(ERRORS).forEach((errorType) => {
      let translationKey = "";
      let prefix = "";

      if (
        errorType.startsWith("EXPIRED_VALIDATION_KEY")
        || errorType.startsWith("INACTIVE_ACCOUNT")
        || errorType.startsWith("PENDING_ACCOUNT")
        || errorType.startsWith("CLOSED_ACCOUNT")
        || errorType.startsWith("BAD_LOGIN_PASSWORD")
        || errorType.startsWith("BAD_VALIDATION_KEY")
        || errorType.startsWith("BAD_LOGIN_OR_EMAIL_PASSWORD")
        || errorType.startsWith("BAD_PASSWORDS")
      ) {
        prefix = "exceptionMessage.";
      }
      else if (
        errorType.startsWith("badAuthorizationScopeForRepository")
        || errorType.startsWith("badMaxIntervalFloatWithComponent")
        || errorType.startsWith("badMinIntervalFloatWithComponent")
        || errorType.startsWith("BAD_VALUE_FOR_EXPRESSION")
        || errorType.startsWith("badValueForExpression")
        || errorType.startsWith("duplicatedHeaders")
        || errorType.startsWith("duplicatedLineInDatatype")
        || errorType.startsWith("duplicatedLineInReference")
        || errorType.startsWith("emptyFile")
        || errorType.startsWith("emptyHeader")
        || errorType.startsWith("headerColumnPatternNotMatching")
        || errorType.startsWith("invalidHeaders")
        || errorType.startsWith("invalidReferenceWithComponent")
        || errorType.startsWith("missingMandatoryColumns")
        || errorType.startsWith("timeRangeOutOfInterval")
        || errorType.startsWith("unexpectedHeaderColumn")
        || errorType.startsWith("unexpectedHeaderColumnsInList")
        || errorType.startsWith("unexpectedTokenCount")
        || errorType.startsWith("invalidFloatWithComponent")
        || errorType.startsWith("invalidIntegerWithComponent")
        || errorType.startsWith("invalidDateWithComponent")
        || errorType.startsWith("requiredValueWithComponent")
        || errorType.startsWith("missingParentLineInRecursiveReference")
        || errorType.startsWith("patternNotMatchedWithComponent")
      ) {
        prefix = "errors-csv.";
      }
      else {
        prefix = "errors-yaml.";
      }

      translationKey = prefix + errorType + ".message";

      const message = i18n.global.t(translationKey);
      const title = i18n.global.t(prefix + errorType + ".title");

      if (message || title) {
        errorMessages[errorType] = {
          message: message,
          title: title,
        };
      }
    });

    return JSON.stringify(errorMessages, null, 2);
  }
}
